// extracted by mini-css-extract-plugin
export default {"businessInfoCards":"Groups_businessInfoCards__j-oSL","groupCardContainer":"Groups_groupCardContainer__zHISU","groupCard":"Groups_groupCard__pAPTx"};